import { create } from "zustand";

type ModalType = "signin" | "forgot" | "register" | null;

interface ModalStore {
  current: ModalType;
  props: Record<string, any>;
}

export const useModalStore = create<ModalStore>(() => ({
  current: null,
  props: {},
}));

export const modalActions = {
  open: (modal: ModalType, props = {}) => {
    const current = useModalStore.getState().current;
    if (current === modal) return;

    document.body.style.overflow = "hidden";
    useModalStore.setState({ current: modal, props });
  },

  close: () => {
    const current = useModalStore.getState().current;
    if (current === null) return;

    document.body.style.overflow = "";
    useModalStore.setState({ current: null, props: {} });
  },
};

export const useCurrentModal = () => useModalStore((state) => state.current);

export const useModalProps = () => useModalStore((state) => state.props);
